<div id="circularMenu" class="circular-menu" [ngClass]="{ active: showLinks }">
  <a class="floating-btn" (click)="showLinks = !showLinks" id="floating-btn">
    <i class="bi bi-plus floating__icon--modification"></i>
  </a>

  <menu class="items-wrapper">
    @if (right?.encodageNouveauEntrant) {
      <a
        class="menu-item"
        [pTooltip]="'circularMenu.createIncomingMail' | translate"
        tooltipPosition="left"
        tooltipZIndex="99999"
        (click)="createCourrier('E')"
        id="floatingButtonItemCourrierEntrant">
        <svg
          class="svgIconEntrant"
          width="17px"
          height="17px"
          viewBox="0 0 12.9981831 13.4994621"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <g id="Medium-Copy-34" transform="translate(-109.000000, -233.500538)" stroke="#FFFFFF" stroke-width="2">
              <g id="Group-5" transform="translate(109.000000, 233.500538)">
                <polyline
                  id="Path-2"
                  points="3.01154927 2.50046398 -1.56632324e-16 2.50046398 0 13.4994621 12.9981831 13.4994621 12.9981831 2.50046398 9.84940583 2.50046398"></polyline>
                <path
                  d="M6.49149171,0 L6.49149171,9.99992398 M6.49149171,9.99992398 L9.52997847,6.99946213 M3.39238704,6.99946213 L6.49909156,9.99992398"
                  id="Combined-Shape"></path>
              </g>
            </g>
          </g>
        </svg>
      </a>
    }

    @if (right?.encodageNouveauSortant) {
      <a
        class="menu-item"
        [pTooltip]="'circularMenu.createOutgoingMail' | translate"
        tooltipPosition="left"
        tooltipZIndex="99999"
        (click)="createCourrier('S')"
        id="floatingButtonItemCourrierSortant">
        <svg
          class="svgIconSortant"
          width="17px"
          height="17px"
          viewBox="0 0 15 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Medium-Copy-34" transform="translate(-107.991492, -295.000000)" fill="#FFFFFF" fill-rule="nonzero">
              <path
                d="M122.928641,295.586957 C122.898653,295.586957 122.898653,295.586957 122.928641,295.586957 C122.838678,295.358696 122.658751,295.163043 122.478825,295.065217 C122.418849,295.032609 122.358873,295 122.298898,295 C122.118971,295 121.939045,295 121.789106,295.065217 C121.759118,295.065217 121.729131,295.097826 121.729131,295.097826 L108.534518,301.293478 C108.23464,301.456522 107.994738,301.782609 107.994738,302.141304 C107.96475,302.5 108.144677,302.858696 108.444555,303.054348 L112.792951,305.663043 L112.792951,309.021739 C112.792951,309.413043 113.002865,309.771739 113.33273,309.902174 C113.452681,309.967391 113.572632,310 113.692583,310 C113.902498,310 114.1424,309.902174 114.292338,309.73913 L116.27153,307.75 L119.240318,309.543478 C119.48022,309.706522 119.780098,309.706522 120.049988,309.576087 C120.319877,309.445652 120.499804,309.184783 120.559779,308.891304 L122.9588,296.173913 C123.018775,296.01087 122.988788,295.782609 122.928812,295.586957 L122.928641,295.586957 Z M113.572461,303.869565 L110.933538,302.271739 L118.1306,298.880435 L113.572461,303.869565 Z M114.596153,306.83913 L114.596153,306.73913 L114.683653,306.78913 L114.596153,306.83913 Z M119.060392,307.195652 L115.1918,304.847826 L120.589596,298.978261 L119.060392,307.195652 Z"
                id="Shape"></path>
            </g>
          </g>
        </svg>
      </a>
    }
    <a
      class="menu-item bi bi-person-vcard"
      [pTooltip]="'circularMenu.createContact' | translate"
      tooltipPosition="left"
      tooltipZIndex="99999"
      (click)="createContact()"
      id="floatingButtonItemContact"></a>
    <a
      class="menu-item bi bi-envelope-at"
      [pTooltip]="'circularMenu.createMailFromEmail' | translate"
      tooltipPosition="left"
      tooltipZIndex="99999"
      (click)="showUploader = true"
      id="floatingButtonItemCourrierMail"></a>
  </menu>
</div>

<p-dialog [header]="'circularMenu.createMailRecord' | translate" styleClass="super-compos-modal-content" [(visible)]="showUploader" [modal]="true">
  <p class="alert alert-info mb-3">
    {{ 'circularMenu.onlyMailsSupported' | translate }}
  </p>
  <div (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" class="w-100 myUploadGlobal">
    {{ 'circularMenu.dragDropFileEmail' | translate }}
  </div>
</p-dialog>
